var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1948 5.02656C11.5267 3.65781 13.4733 3.65781 13.8052 5.02656L14.7185 8.79277C14.837 9.28146 15.2185 9.66301 15.7072 9.78151L19.4734 10.6948C20.8422 11.0267 20.8422 12.9733 19.4734 13.3052L15.7072 14.2185C15.2185 14.337 14.837 14.7185 14.7185 15.2072L13.8052 18.9734C13.4733 20.3422 11.5267 20.3422 11.1948 18.9734L10.2815 15.2072C10.163 14.7185 9.78146 14.337 9.29277 14.2185L5.52656 13.3052C4.15781 12.9733 4.15781 11.0267 5.52656 10.6948L9.29277 9.78151C9.78146 9.66301 10.163 9.28146 10.2815 8.79277L11.1948 5.02656Z",
    fill: "#C4C2F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 23C5.94771 23 5.5 22.5523 5.5 22C5.5 21.4477 5.94771 21 6.5 21C7.05228 21 7.5 21.4477 7.5 22C7.5 22.5523 7.05228 23 6.5 23Z",
    fill: "#C4C2F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 3C17.9477 3 17.5 2.55228 17.5 2C17.5 1.44772 17.9477 1 18.5 1C19.0523 1 19.5 1.44772 19.5 2C19.5 2.55228 19.0523 3 18.5 3Z",
    fill: "#C4C2F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7C21.9477 7 21.5 6.55228 21.5 6C21.5 5.44771 21.9477 5 22.5 5C23.0523 5 23.5 5.44771 23.5 6C23.5 6.55228 23.0523 7 22.5 7Z",
    fill: "#C4C2F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8147 14.9953C23.2804 15.1692 23.517 15.6876 23.3432 16.1532C22.2173 19.1697 19.8801 21.5926 16.9228 22.8302C16.4643 23.0221 15.9371 22.806 15.7452 22.3474C15.5533 21.8889 15.7694 21.3617 16.228 21.1698C18.7274 20.1238 20.7052 18.0734 21.6568 15.5238C21.8306 15.0581 22.349 14.8215 22.8147 14.9953Z",
    fill: "#C4C2F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52077 1.68464C9.69494 2.15018 9.45874 2.66877 8.9932 2.84294C6.42955 3.80206 4.37073 5.8029 3.33251 8.33064C3.14367 8.79043 2.61785 9.01007 2.15806 8.82122C1.69828 8.63237 1.47864 8.10655 1.66749 7.64677C2.89534 4.6573 5.32798 2.29233 8.36247 1.15706C8.82801 0.982891 9.3466 1.2191 9.52077 1.68464Z",
    fill: "#C4C2F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 19C1.94772 19 1.5 18.5523 1.5 18C1.5 17.4477 1.94772 17 2.5 17C3.05228 17 3.5 17.4477 3.5 18C3.5 18.5523 3.05228 19 2.5 19Z",
    fill: "#C4C2F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6d152930bf3952b53329a245caf7379e.svg";
export { ForwardRef as ReactComponent };